export default __webpack_public_path__ + "static/media/tier_ranking.49f62c36.png";